import { connect } from 'react-redux';
import { setOrderDetails } from '../../../actions/orders';
import QuantityInput from './QuantityInput';

export default connect(
  ({ order, settings, product }) => ({
    bookingToken: settings.bookingToken,
    variantSelected: order.variantSelected,
    variants: product.data.variants,
    quantity: order.quantity,
    style: settings.style,
    setting: settings.setting,
  }),
  (dispatch) => ({
    onSetOrderDetails: (value) => dispatch(setOrderDetails(value)),
  }),
)(QuantityInput);
